<!-- <template>
  <div>
	<div v-for='desc in descriptions'>
    <v-chip label>
    <v-avatar
    size='16px'>
  <img :src='desc.iconAddress'>
  </img>
  </v-avatar>
		{{desc['name']}}
  </v-chip>
  <v-badge right bottom color='blue lighten-1' v-model="desc['hasExtraInfo']" >
      {{desc['description']}}
    <span slot='badge'><v-icon dark>subdirectory_arrow_left</v-icon></span>
  </v-badge>
	</div>
</div>
</template> -->
<template>
  <v-expansion-panel color='blue'>
    <v-expansion-panel-content
    v-for='desc in descriptions'
    :key='desc.name'
    :hideActions='!desc["hasExtraInfo"]'
    >
    <div slot='header'>
      <v-chip label>
    <v-avatar
    size='16px'>
  <img :src='desc.iconAddress'>
  </img>
  </v-avatar>
    {{desc['name']}}
  </v-chip>
   {{desc['description']}}
    </div>
    <v-card v-for='extra in desc["extraInfo"]' :key='extra.name' class='blue lighten-5'>
      <v-card-text>
        <span><h1 class='title'>{{extra['name']}}</h1></span>
        <span v-if="extra['data'].length>0">{{extra['data']}}</span>
        <span v-else>no information</span>
      </v-card-text>
    </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
  data () {
    return {
      descriptions: [],
      hasMoreInfo: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/map/MapboxPopup.vue